<div class="sales-area-page-container container">
  <p>{{Dictionary.tooltipSalesArea}}</p>
  <p>{{Dictionary.tooltipTotalArea}}</p>
  <p>{{ 'SALES_AREA_RATIO' | translate }}</p>
  <hr />
  <mtn-key-value key="{{ 'TOTAL_AREA' | translate }}">
    <span *ngIf="store.totalArea; else notAvailable">{{ store.totalArea.toLocaleString() }} sqft</span>
  </mtn-key-value>
  <mtn-key-value key="{{ 'SALES_AREA' | translate }}">
    <span *ngIf="store.grocerySalesArea; else notAvailable">
      {{ store.grocerySalesArea.toLocaleString() }} sqft
      <span *ngIf="salesAreaPercentage">({{ salesAreaPercentage }}% {{ 'OF_TOTAL_AREA' | translate }})</span>
    </span>
  </mtn-key-value>
</div>

<ng-template #notAvailable>
  <span class="color-muted">{{ 'NOT_AVAILABLE' | translate }}</span>
</ng-template>
